import { Encoder, MGPFallible, MGPOptional } from '@everyboard/lib';
import { Move } from '../../jscaip/Move';
import { Player } from '../../jscaip/Player';
import { ApagosFailure } from './ApagosFailure';
export class ApagosMove extends Move {
    landing;
    piece;
    starting;
    static encoder = Encoder.tuple([
        Encoder.identity(),
        MGPOptional.getEncoder(Player.encoder),
        MGPOptional.getEncoder(Encoder.identity()),
    ], (m) => [m.landing, m.piece, m.starting], (fields) => new ApagosMove(fields[0], fields[1], fields[2]));
    static drop(x, piece) {
        return new ApagosMove(x, MGPOptional.of(piece), MGPOptional.empty());
    }
    static transfer(start, landing) {
        if (start <= landing) {
            return MGPFallible.failure(ApagosFailure.PIECE_SHOULD_MOVE_DOWNWARD());
        }
        const slideDown = new ApagosMove(landing, MGPOptional.empty(), MGPOptional.of(start));
        return MGPFallible.success(slideDown);
    }
    constructor(landing, piece, starting) {
        super();
        this.landing = landing;
        this.piece = piece;
        this.starting = starting;
    }
    isDrop() {
        return this.piece.isPresent();
    }
    toString() {
        if (this.isDrop()) {
            return 'ApagosMove.drop(' + this.piece.get().toString() + ' on ' + this.landing + ')';
        }
        else {
            return 'ApagosMove.slideDown(' + this.starting.get() + ' > ' + this.landing + ')';
        }
    }
    equals(other) {
        if (this.landing !== other.landing)
            return false;
        if (this.starting.equals(other.starting) === false)
            return false;
        return this.piece.equals(other.piece);
    }
}
